import { render, staticRenderFns } from "./MailVisitors.vue?vue&type=template&id=052a393a&scoped=true"
import script from "./MailVisitors.vue?vue&type=script&lang=js"
export * from "./MailVisitors.vue?vue&type=script&lang=js"
import style0 from "./MailVisitors.vue?vue&type=style&index=0&id=052a393a&prod&lang=scss"
import style1 from "./MailVisitors.vue?vue&type=style&index=1&id=052a393a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052a393a",
  null
  
)

export default component.exports